
/* START_TEMPLATE */
define('hbs!app/views/templates/processingPPPayment',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<p>"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.paymentProcessing : stack1)) != null ? stack1.paymentProcessingMessage : stack1), depth0))
    + "</p>\r\n";
},"useData":true});
Handlebars.registerPartial('app/views/templates/processingPPPayment', t);
return t;
});
/* END_TEMPLATE */
;
